import ParticlesComponent from '@c/particles/ParticlesComponent';
import { getProductSlug } from '@util/urlHelpers';
import { ProductDocument } from 'models/product';
import { useRouter, useSearchParams } from 'next/navigation';
import ShareModal from './ShareModal';

const ShareProductModal = ({ product }: { product: ProductDocument }) => {
  const params = useSearchParams();
  const router = useRouter();
  return (
    <>
      <ShareModal
        title={product.title}
        thumb={product.thumbnail}
        id={product.id}
        isOpen={!!params?.get('share')}
        dismiss={() => router.replace(getProductSlug(product))}
        removeQuery
      />

      {!!params?.get('share') && <ParticlesComponent />}
    </>
  );
};

export default ShareProductModal;
